"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalBusinessComparison() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section data-section-id="129865" id="gömülü-diş-operasyonları-giriş" className="bg-background text-foreground relative flex min-h-[80vh] flex-col items-center justify-center overflow-hidden py-[120px]">
      {}
      <div className="absolute inset-0 z-0 opacity-40" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23c5a059' fill-opacity='0.2'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} />

      {}
      <div className="absolute top-1/2 left-1/2 z-0 -translate-x-1/2 -translate-y-1/2 h-[40rem] w-[40rem] rounded-full bg-primary/20 blur-[120px]" />

      <div ref={ref} className={`container relative z-10 mx-auto flex max-w-4xl flex-col items-center px-4 text-center transition-all duration-[1200ms] ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        {}
        <div className="mb-8 inline-flex items-center rounded-sm border border-border bg-card/50 px-4 py-1.5 text-sm font-medium text-muted-foreground backdrop-blur-md">
          <span className="mr-2 flex size-2 rounded-full bg-primary animate-pulse"></span>
          İleri Cerrahi Yaklaşımı
        </div>

        {}
        <h1 className="font-serif text-5xl font-light tracking-[0.1em] sm:text-6xl md:text-7xl lg:text-[84px]">
          <span className="bg-gradient-to-br from-foreground via-foreground/90 to-primary bg-clip-text text-transparent">
            Gömülü Diş
          </span>
          <br />
          <span className="bg-gradient-to-br from-foreground/80 to-muted-foreground bg-clip-text text-transparent">
            Operasyonları
          </span>
        </h1>

        {}
        <p className="mt-8 max-w-2xl text-[18px] leading-relaxed text-muted-foreground sm:text-xl font-sans">Modern cerrahi tekniklerimiz ve ileri teknolojik donanımımızla, <strong className="text-foreground font-semibold" data-ast-id="f:/src/pages/ImpactedToothSurgeries/sections/LocalBusinessComparison.tsx|sig:rv4ov3" data-ast-start="2433" data-ast-end="2518">gömülü diş operasyonlarını</strong> tamamen ağrısız, güvenli ve <strong className="text-foreground font-semibold" data-ast-id="f:/src/pages/ImpactedToothSurgeries/sections/LocalBusinessComparison.tsx|sig:rv4ov4" data-ast-start="2547" data-ast-end="2612" contenteditable="false" style={{}}>konfor</strong>&nbsp;standartlarında gerçekleştiriyoruz.</p>

        {}
        <div className="mt-24 flex flex-col items-center gap-4">
          <span className="text-sm font-medium uppercase tracking-widest text-muted-foreground/80">
            Randevu Al
          </span>
          <Link to="/ContactPage" className="group flex size-16 items-center justify-center rounded-sm border border-border bg-gradient-to-br from-primary to-chart-2 backdrop-blur-sm transition-all shadow-md hover:shadow-lg hover:scale-105" aria-label="Randevu Al">
            <ChevronDown className="size-8 animate-bounce text-primary-foreground transition-transform group-hover:scale-110" />
          </Link>
        </div>
      </div>
    </section>;
}